exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart[data-v-61ef8ce1]{width:100%;height:100%}\n", ""]);

// exports
